export const pharmacyConstant = {
    GET: 'PHARMACY_GET'
};
